import {AbstractService} from 'services/AbstractService';

const BIDMANAGER_GROUP_CREATE_URL = '/api/projects/{0}/bidmanager/groups';
const BIDMANAGER_GROUP_DELETE_URL = '/api/projects/{0}/bidmanager/groups';
const BIDMANAGER_GROUP_DETAIL_URL = '/api/projects/{0}/bidmanager/groups/{1}';
const BIDMANAGER_GROUP_ENABLING_URL = '/api/projects/{0}/bidmanager/groups/enabled';
const PROGRESS_METRICS_LIST_URL = '/api/projects/{0}/bidmanager/progressmetrics';
const GROUP_PROGRESS_URL = '/api/projects/{0}/bidmanager/groups/progress';
const BIDMANAGER_PARAMS_URL = '/api/projects/{0}/bidmanager/params/{1}';

export class BidManagerService extends AbstractService {
  get (accountId, projectId, groupId) {
    return this.client.get(BIDMANAGER_GROUP_DETAIL_URL.format(projectId, groupId), {}, {accountId});
  }

  create (accountId, projectId, groupData) {
    return this.client.post(BIDMANAGER_GROUP_CREATE_URL.format(projectId), groupData, {accountId});
  }

  update (accountId, projectId, groupId, groupData) {
    return this.client.put(BIDMANAGER_GROUP_DETAIL_URL.format(projectId, groupId), groupData, {accountId});
  }

  delete (accountId, projectId, id) {
    return this.client.delete(BIDMANAGER_GROUP_DELETE_URL.format(projectId), {id}, {accountId});
  }

  getGroups (accountId, projectId, params) {
    return this.client.get(BIDMANAGER_GROUP_CREATE_URL.format(projectId), params, {accountId});
  }

  getParams (accountId, projectId, channelId) {
    return this.client.get(BIDMANAGER_PARAMS_URL.format(projectId, channelId), {}, {accountId});
  }

  activateEnabling (accountId, projectId, id) {
    return this.client.put(
      BIDMANAGER_GROUP_ENABLING_URL.format(projectId),
      {project_id: projectId},
      {accountId},
      {params: {id}}
    );
  }

  deactivateEnabling (accountId, projectId, id) {
    return this.client.delete(
      BIDMANAGER_GROUP_ENABLING_URL.format(projectId),
      {id},
      {accountId}
    );
  }

  getProgressMetricsList (accountId, projectId) {
    return this.client.get(
      PROGRESS_METRICS_LIST_URL.format(projectId),
      {},
      {accountId}
    );
  }

  getGroupProgress (accountId, projectId, groupIds) {
    return this.client.get(
      GROUP_PROGRESS_URL.format(projectId),
      {group_id: groupIds},
      {accountId}
    );
  }
}
